import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'utils/axiosBaseQuery';

// Define a service using a base URL and expected endpoints
export const signUp = createApi({
  reducerPath: 'signUpApi',
  baseQuery: axiosBaseQuery(),
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getCountryList: builder.query({
      query: ({ country }) => ({
        method: 'GET',
        path: `publicdata/GetCountries/${country}`,
      }),
    }),

    getCityList: builder.query({
      query: ({ country, city }) => ({
        method: 'GET',
        path: `publicdata/GetCities/${country}/${city}`,
      }),
    }),
    getDistrictsList: builder.query({
      query: ({ country, cityId, districts }) => ({
        method: 'GET',
        path: `PublicData/GetDistricts/${country}/${cityId}/${districts}`,
      }),
    }),
    getPostalCode: builder.query({
      query: ({ country, cityId, district, code }) => ({
        method: 'GET',
        path: `PublicData/GetPostalCodes/${country}/${cityId}/${district}/${code}/`,
      }),
    }),
    checkTcIdentity: builder.mutation({
      query: ({ kn }) => ({
        method: 'GET',
        path: `PublicData/TcknCheck?kn=${kn}`,
      }),
    }),
    checkVkn: builder.mutation({
      query: ({ vkn }) => ({
        method: 'GET',
        path: `PublicData/VknCheck/${vkn}`,
      }),
    }),
    getCheckIsUserExist: builder.query({
      query: ({ queries }) => ({
        method: 'GET',
        path: `Login/CheckUserIfExists${queries}`,
      }),
    }),
    login: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'POST',
        path: 'Login/login',
      }),
    }),
    forgotPassword: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'POST',
        path: 'Login/ForgotPasswordRequest',
      }),
    }),
    resetPassword: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'POST',
        path: 'Login/ResetPasswordRequest',
      }),
    }),
    register: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'POST',
        path: 'login/PublicRegister',
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const signUpApiReducerName = signUp.reducerPath;
export const signUpApiReducer = signUp.reducer;
export const signUpMiddleware = signUp.middleware;

export const {
  useGetCountryListQuery,
  useGetCityListQuery,
  useGetDistrictsListQuery,
  useGetPostalCodeQuery,
  useGetCheckIsUserExistQuery,
  useCheckTcIdentityMutation,
  useCheckVknMutation,
  useLoginMutation,
  useRegisterMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
} = signUp;
